import { SensorsEvent } from './src/SensorsEvent'
import { SensorsConfig } from './src/SensorsConfig'
import { initSensors } from './src/Sensors'
import Tracking from './src/Tracking'

let options = {}
export const setOptions = L => options = L
export const Options = () => options
/**
 * @param Vue
 * @param options sensorsOption, enableTrack, sensorsProject
 */
const install = function (Vue = {}, options = SensorsConfig.init(undefined, undefined)) {
  if (install.installed) return
  _clearLocalStorage()
  try {
    initSensorsPlugin(Vue, options)
    Vue.use(Tracking)
  } catch (e) {
    if (options.lube && options.runEnv !== 'prod') {
      console.warn(e)
    }
  }

}


/**
 * 初始化神策插件
 * @param Vue 框架
 * @param options SensorsConfig
 */
const initSensorsPlugin = async (Vue = {}, options) => {
  if (!options.sensorsInited) throw new Error('请使用 configSensors 方法配置神策, 如果不需要使用可以忽略警告')
  // 初始化神策

  if (options.enableTrack) window.sensors = await initSensors(options)
}

const _clearLocalStorage = () => {
  const keyArr = Object.keys(localStorage) || []
  let list = keyArr.filter(item => item.indexOf("tab-sawebjssdk-") > -1)
  list.forEach(item => {
    localStorage.removeItem(item)
  })
}

export default {
  install,
  SensorsEvent,
  SensorsConfig
}

export {
  SensorsEvent,
  SensorsConfig
}
